<!--我的账号-->
<template>
  <div class="loginLog">
    <div class="page-title">登录记录</div>
    <div class="top-info">
      {{userInfo.enterpriseName}}，以下是您的登录记录，若存在异常登录记录，请尽快<span @click="changePassword()">修改密码</span>
    </div>
    <date-range :timeDate.sync="timeDate" @dateValue="changeDate" :thisClearable="'true'"></date-range>
    <div class="tableBox">
      <el-table class="roleTable" :data="loginLogList" border v-loading="listLoading">
        <el-table-column prop="loginTime" label="登录时间"></el-table-column>
        <el-table-column prop="loginIp" label="登录地点（IP）"></el-table-column>
        <el-table-column prop="deviceType" label="登录设备"></el-table-column>
        <el-table-column prop="loginType" label="登录方式">
          <template slot-scope="scope">
            {{scope.row.loginType===1?'账号密码':'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="platform" label="登录模块">
          <template slot-scope="scope">
            {{scope.row.platform===1?'巨量引擎':'巨量千川'}}
          </template>
        </el-table-column>
      </el-table>
      <div class="paging-box" v-if="pageTotal > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 80, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
    <change-password ref="changePasswordRef"></change-password>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
// 公用
import { getTimeAll } from '@/components/public'
// 组件
import changePassword from './changePassword.vue'
import dateRange from './../../components/common/dateRange'

export default {
  name: 'loginLog',
  components: {
    changePassword,
    dateRange
  },
  data () {
    return {
      listLoading: false,
      loginLogList: [],
      // 分页相关
      currentPage: 1, // 初始当前显示页
      pagesize: 10, // 初始每页的数据条数
      pageTotal: 0, // 数据总条数
      timeDate: []

    }
  },
  created () {
    this.getLogList()
  },
  mounted () {
  },
  methods: {
    // 选择日期变更
    changeDate(val) {
      this.timeDate = val
      this.getLogList()
    },
    getLogList() {
      this.listLoading = true
      let startTime = ''
      let endTime = ''
      if (this.timeDate !== []) {
        startTime = this.timeDate[0]
        endTime = this.timeDate[1]
      }
      let param = {
        endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pagesize,
        projectId: this.screeningProject,
        startTime: startTime
      }
      this.$service.post('/api/user/getLoginLogList', param).then(res => {
        if (res.result) {
          res.result.pageData.map(item => { item.loginTime = getTimeAll(new Date(item.loginTime)) })
          this.loginLogList = res.result.pageData
          this.pageTotal = res.result.total
        } else {
          this.loginLogList = []
          this.pageTotal = 0
        }
        this.listLoading = false
      }).catch(Err => {
        this.listLoading = false
      })
    },
    changePassword() {
      this.$refs.changePasswordRef.changePasswordVisible = true
    },
    // 切换数据显示条数
    handleSizeChange(size) {
      this.pagesize = size
      this.getLogList()
    },
    // 切换分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getLogList()
    }
  },
  computed: {
    ...mapGetters(['screeningProject']),
    ...mapState(['userInfo'])
  }
}
</script>
<style lang="less" scoped>
@import './../../styles/common/public.less';
.loginLog{
  .top-info{
    padding: 10px 0 20px;
    b{
      font-weight: normal;
    }
    span{
      color: @color;
      display: inline-block;
      margin: 0 5px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/accountInfoCenter/loginLog.vue